import debug from "debug";

export default (nameSpace: string) => {
  debug.disable();

  if (process.env.NODE_ENV === "development") {
    debug.enable("CP:*");
  } else {
    debug.enable("CP:*:ERROR");
  }

  // STDOUT Log
  const log = debug(`CP:${nameSpace}`);
  const info = debug(`CP:${nameSpace}:INFO`);

  // @ts-ignore
  log.log = console.log.bind(console);
  // @ts-ignore
  log.info = console.log.bind(console);

  // Error Log
  const error = debug(`CP:${nameSpace}:ERROR`);

  // @ts-ignore
  error.log = console.error.bind(console);

  return {
    error,
    log,
    info
  };
};
